import {View} from "../../km_app/types/View";
import {PropertyListType} from "../types/IPropertyListType";
import {IPropertyState} from "../types/IPropertyState";

export const propertyPhoneModalInitialState: IPropertyState["phoneModal"] = {
    isOpen: false,
    itemId: 0,
    itemType: PropertyListType.Recommendation,
    viewType: View.MY_OFFER
};
import {View} from "../../km_app/types/View";
import {PropertyListType} from "../types/IPropertyListType";
import {IPropertyState} from "../types/IPropertyState";

export const propertyPhoneModalInitialState: IPropertyState["phoneModal"] = {
    isOpen: false,
    itemId: 0,
    itemType: PropertyListType.Recommendation,
    viewType: View.MY_OFFER
};
